module.exports = __webpack_public_path__ + "img/Bientot.b00ec121.png";